module.exports = __webpack_public_path__ + "9916f191cf995b78c61c08f10c3e194c.svg";